var map = {
	"./en/account.json": 43594,
	"./en/actions.json": 10435,
	"./en/entities.json": 17044,
	"./en/footer.json": 1935,
	"./en/landing.json": 95646,
	"./en/leaderboard.json": 37135,
	"./en/login.json": 97001,
	"./en/popovers.json": 95220,
	"./en/sponsors.json": 69203,
	"./en/submit.json": 49086,
	"./en/submitted.json": 65203,
	"./en/translation.json": 59842,
	"./en/validation.json": 91334,
	"./en/variants.json": 21621,
	"./en/wordcount.json": 72946,
	"./es/account.json": 51159,
	"./es/actions.json": 57289,
	"./es/entities.json": 91112,
	"./es/footer.json": 41875,
	"./es/landing.json": 27322,
	"./es/leaderboard.json": 64927,
	"./es/login.json": 53013,
	"./es/popovers.json": 90289,
	"./es/sponsors.json": 56,
	"./es/submit.json": 43206,
	"./es/submitted.json": 62402,
	"./es/translation.json": 56658,
	"./es/validation.json": 63513,
	"./es/variants.json": 28426,
	"./es/wordcount.json": 38088,
	"./fr/account.json": 38276,
	"./fr/actions.json": 42541,
	"./fr/entities.json": 35402,
	"./fr/footer.json": 77932,
	"./fr/landing.json": 62398,
	"./fr/leaderboard.json": 61518,
	"./fr/login.json": 13050,
	"./fr/popovers.json": 18682,
	"./fr/sponsors.json": 21779,
	"./fr/submit.json": 98386,
	"./fr/submitted.json": 22892,
	"./fr/translation.json": 57331,
	"./fr/validation.json": 38764,
	"./fr/variants.json": 13504,
	"./fr/wordcount.json": 3712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38149;